import QRCode from "qrcode";
import logoQr from "../../asset/gnb/logo_qr.png";
import logoQrTransparent from "../../asset/gnb/logo_qr_transparent.png";

/** 다운로드·미리보기와 동일한 PNG 캔버스 */
export async function buildQRCodeCanvas(
  value: string,
  isTransparent: boolean = true,
): Promise<HTMLCanvasElement | null> {
  const logoSizeRatio = 0.34;
  const canvas = document.createElement("canvas");
  await QRCode.toCanvas(canvas, value, {
    errorCorrectionLevel: "H",
    scale: 12,
    margin: 4,
    color: { dark: "#111111", light: isTransparent ? "#00000000" : "#FCFBFB" },
  });

  const ctx = canvas.getContext("2d");
  if (!ctx) return null;

  if (isTransparent) {
    const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
    const data = imageData.data;

    for (let i = 0; i < data.length; i += 4) {
      const r = data[i];
      const g = data[i + 1];
      const b = data[i + 2];

      if (r >= 250 && g >= 250 && b >= 250) {
        data[i + 3] = 0;
      }
    }

    ctx.putImageData(imageData, 0, 0);
  }

  const selectedLogoUrl = isTransparent ? logoQrTransparent : logoQr;

  if (selectedLogoUrl) {
    const logo = new Image();
    logo.crossOrigin = "anonymous";

    await new Promise<void>((resolve, reject) => {
      logo.onload = () => resolve();
      logo.onerror = () => reject(new Error("Failed to load logo image"));
      logo.src = selectedLogoUrl;
    });

    const logoSize = canvas.width * logoSizeRatio;
    const logoX = (canvas.width - logoSize) / 2;
    const logoY = (canvas.height - logoSize) / 2;

    if (isTransparent) {
      const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
      const data = imageData.data;

      for (let y = Math.max(0, Math.floor(logoY)); y < Math.min(canvas.height, Math.ceil(logoY + logoSize)); y++) {
        for (let x = Math.max(0, Math.floor(logoX)); x < Math.min(canvas.width, Math.ceil(logoX + logoSize)); x++) {
          const index = (y * canvas.width + x) * 4;
          data[index + 3] = 0;
        }
      }

      ctx.putImageData(imageData, 0, 0);
    }

    ctx.drawImage(logo, logoX, logoY, logoSize, logoSize);
  }

  return canvas;
}

export async function getQRCodeDataUrl(
  value: string,
  isTransparent: boolean = true,
): Promise<string | null> {
  const canvas = await buildQRCodeCanvas(value, isTransparent);
  if (!canvas) return null;
  return canvas.toDataURL("image/png");
}

export async function downloadQRPNG(
  value: string,
  filename = "qr.png",
  isTransparent: boolean = true
) {
  const canvas = await buildQRCodeCanvas(value, isTransparent);
  if (!canvas) return;

  const blob = await new Promise<Blob | null>((res) =>
    canvas.toBlob((b) => res(b), "image/png")
  );

  if (!blob) return;

  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);

  setTimeout(() => URL.revokeObjectURL(url), 1000);
}
